import { UserInvestor } from './model/user-investor.model';
import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { UserSignupDataService } from './user-signup-data.service';
import { DomainOrigin } from './model/domain-origin';

@Injectable({
  providedIn: 'root'
})
export class UserUpdateDataMobileService implements UserSignupDataService{

  constructor(private handlerService: HandlerService) {}

  public postUserSignup(userData: UserInvestor, id_investidor?: string): Promise<any> {
    const relCaronte = 'user-edit';
    const idInvestidor = { id_investidor : id_investidor}

    return this.handlerService.caronteCommunicator(relCaronte, userData, idInvestidor, true).then((data: any) => {
      if (data) {
        return Promise.resolve(data);
      } else {
        return Promise.reject(data);
      }
    });
  }

  getOrigin(): DomainOrigin {
    return DomainOrigin.UpdateRegistration;
  }
}

